const WORDS = ["Buy", "Sell", "Rent", "Residential", "Commercial", "Plots", "Investment"];

const Row = () => (
  <div className="flex items-center gap-10 pr-10 shrink-0">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center gap-10">
        <span
          className="font-display italic text-4xl sm:text-6xl lg:text-7xl whitespace-nowrap"
          style={i % 2 ? { WebkitTextStroke: "1.2px #0B1F33", color: "transparent" } : { color: "#0B1F33" }}
        >
          {w}
        </span>
        <span className="text-gold text-xl sm:text-2xl">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="bg-warm border-y border-line py-8 sm:py-10 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
